<div class="status screen-reader-only" aria-live="polite" aria-atomic="true">{{ changedStatusText }}</div>
@if (isAutoStart) {
  <div>
    <section class="bankid-auth-content">
      <div class="status">{{ changedStatusText }}</div>
      @if (statusMessage === 101) {
        <div class="spinner-wrapper">
          <i class="icon-spinner hogia-spin spinner-md" role="status"><span class="screen-reader-only">Loading...</span> </i>
        </div>
      }
      @if (showFailedStatusWindow) {
        <astral-button
          class="try-again-button"
          type="button"
          variant="primary"
          labelKey="COMMON.TRY_AGAIN"
          (click)="resetCountdownAndRestartService()"
        ></astral-button>
      }
    </section>
  </div>
} @else {
  @if (!showFailedStatusWindow) {
    <section class="bankid-auth-content">
      <div class="status">{{ changedStatusText }}</div>
      <div class="authentication-wrapper">
        <button [attr.aria-label]="'ARIA_LABEL.QR_CODE_BUTTON' | translate" class="qr-code-wrapper" (click)="toggleFullscreen()">
          @if (statusMessage !== -105 && qrCode) {
            <qrcode
              [ngClass]="{ 'hidden-qr-code': statusMessage !== -105 }"
              [allowEmptyString]="true"
              [qrdata]="qrCode"
              [width]="185"
              [errorCorrectionLevel]="'M'"
            ></qrcode>
          } @else {
            <div class="qr-code-placeholder"></div>
          }
        </button>
        <progress-bar-countdown
          [shouldAnnounceTime]="shouldAnnounceTime"
          [totalSeconds]="totalSeconds"
          [countdown$]="countdown$"
          (extend)="resetCountdown()"
          />
        </div>
      </section>
    } @else {
      <section class="bankid-auth-content">
        <h2>{{ 'LOGIN_BANKID.ERROR_BANKID_HEADER' | translate }}</h2>
        <div aria-live="polite" aria-atomic="true" class="status timeout-status">{{ 'LOGIN_BANKID.ERROR_BANKID_TIMEOUT' | translate }}</div>
        <astral-button
          type="button"
          variant="primary"
          labelKey="COMMON.TRY_AGAIN"
          (click)="resetCountdownAndRestartService()"
        ></astral-button>
      </section>
    }
    <!-- If the attempt failed during manual start, show this window with information -->
  }

  <!-- Only show QR-code on manual start ("BankID on other application") -->
